import { Chip } from '@mui/material'
import { GridColDef } from '@microservices/wiskey-react-table-component'

export const DRAFT_COLUMN: GridColDef = {
  field: '_isDraft',
  headerName: '',
  width: 80,
  sortable: false,
  disableColumnMenu: true,
  renderCell: (params: any) =>
    params.value ? (
      <Chip label='Draft' size='small' color='warning' variant='outlined' />
    ) : null,
}
